import { useMediaQuery } from '@mui/material';
import { createContext, useContext, useEffect, useState } from 'react';

const ViewportContext = createContext({});

const ViewportProvider = ({ children }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const handleWindowResize = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    };

    const matches = {
        mobile: useMediaQuery((theme) => theme.breakpoints.down('tablet')),
        tablet: useMediaQuery((theme) => theme.breakpoints.between('tablet', 'desktop')),
        desktop: useMediaQuery((theme) => theme.breakpoints.up('desktop')),
    };

    const device = Object.entries(matches).find(([, value]) => value)[0];

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    return <ViewportContext.Provider value={{ width, height, device }}>{children}</ViewportContext.Provider>;
};

const useViewport = () => {
    const { width, height, device } = useContext(ViewportContext);
    return { width, height, device };
};

export { useViewport };
export default ViewportProvider;
